module.exports = __webpack_public_path__ + "static/judge-davis-logo-4252cc1302ccc226029727bfe178460e.png";